// src/components/auth/Login.js
import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Auth.module.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, error } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(email, password);
    setLoading(false);
    if (success) {
      navigate('/dashboard');
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.authCard}>
        <div className={styles.authHeader}>
          <h1 className={styles.authHeaderTitle}>BANNAI'S BAR</h1>
          <p className={styles.authSubtitle}>最高の一杯をあなたに</p>
        </div>
        
        {/* <h2 className={styles.authTitle}>ログイン</h2> */}
        
        {error && (
          <div className={styles.errorMessage}>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              メールアドレス
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.formInput}
              placeholder="example@example.com"
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              パスワード
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.formInput}
              placeholder="パスワードを入力"
              required
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className={styles.formButton}
          >
            {loading ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>
        
        <div className={styles.authLinks}>
          <Link to="/signup" className={styles.authLink}>新規登録</Link>
          <span className={styles.authLinkSeparator}>|</span>
          <Link to="/reset-password" className={styles.authLink}>パスワードを忘れた方</Link>
        </div>
      </div>
    </div>
  );
};

export { Login };